import authRules from '../authRules';

const addAssignmentEditDescription = (user) => {
  const { assignmentComment } = user.securityLevels;
  if (assignmentComment >= authRules.addAssignmentEditDescription.assignmentComment) {
    return true;
  } else {
    return false;
  }
}

export default addAssignmentEditDescription;



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/addAssignmentEditDescription.js